import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { ButtonLink } from '../ui/ButtonLink';
import { WorkspacePreview } from '../scenes/WorkspacePreview';
import type { Workspace } from '../../types/content';
export function WorkspaceHero({
  workspace
}: {
  workspace: Workspace;
}) {
  const Icon = workspace.icon;
  return <section className="relative overflow-hidden pb-20 pt-10 md:pb-28 md:pt-14" data-id="element-493" data-mp="1vb0vlj8754kd">
      <div className="bg-dots pointer-events-none absolute inset-x-0 bottom-0 top-1/2" aria-hidden="true" data-id="element-494" data-mp="1v8xti0trrkza" />
      <div className="relative mx-auto max-w-7xl px-5 md:px-8" data-id="element-495" data-mp="207rba5g39y59">
        <nav aria-label="Breadcrumb" className="flex items-center gap-1 text-sm text-ink-muted" data-id="element-496" data-mp="1lc1mjzjir6wu">
          <Link to="/workspaces" className="transition-colors duration-150 hover:text-ink" data-id="element-497" data-mp="1qamoc3ef5yne">
            Workspaces
          </Link>
          <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-498" data-mp="a00r61s5gk84" />
          <span className="text-ink" data-id="element-499" data-mp="eybzg82sqmo8">{workspace.name}</span>
        </nav>

        <div className="mt-10 grid gap-10 lg:grid-cols-[1.15fr_1fr] lg:items-end" data-id="element-500" data-mp="1hw161ghxkvjz">
          <div data-id="element-501" data-mp="1cwg5j1n44f55">
            <p className="flex items-center gap-2 text-sm font-medium text-accent" data-id="element-502" data-mp="1cwyd2uf86fsd">
              <Icon className="h-4 w-4" aria-hidden="true" data-id="element-503" data-mp="1qw7icz1w7phk" />
              {workspace.audience}
            </p>
            <h1 className="mt-4 text-balance text-4xl font-semibold leading-[1.04] tracking-display sm:text-5xl md:text-6xl" data-id="element-504" data-mp="1lvjqyc9r56mt">
              {workspace.headline}
            </h1>
          </div>
          <div data-id="element-505" data-mp="1vvkbu2n9rut4">
            <p className="text-lg leading-relaxed text-ink-soft" data-id="element-506" data-mp="1vtzhoe4vadvs">{workspace.intro}</p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row" data-id="element-507" data-mp="29l4aoxdqc7x5">
              <ButtonLink href={workspace.demo.url} icon="external" data-id="element-508" data-mp="25kkhu606vqgt">
                Try the {workspace.name} demo
              </ButtonLink>
              <ButtonLink to={`/contact?workspace=${workspace.slug}`} variant="secondary" data-id="element-509" data-mp="2jl4x4s6wb45k">
                Discuss implementation
              </ButtonLink>
            </div>
          </div>
        </div>

        <div className="mx-auto mt-16 max-w-6xl" data-id="element-510" data-mp="1c95hjxsb600z">
          <WorkspacePreview data={workspace.preview} workspaceName={workspace.name} data-id="element-511" data-mp="1g9frtmn4vcln" />
        </div>
      </div>
    </section>;
}